const Destination = require('../entities/destination');

const diff = require('../utils/diff');

const AccessContext = require('./contexts/access-context');

const fields = ['id', 'type', 'url', 'config(secret,batchSize,batchWindowInSeconds)'];

class DestinationRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: destinationId*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.id = id;
    this.context = context;
  }

  details()
  /*: (Promise<Destination>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context && this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/destinations/${this.id}` : `/businesses/${businessId}/destinations/${this.id}`;
    const req = new this.client.Request(path, {}, fields);
    req.parse = Destination.fromJson;
    return this.client.get(req);
  }

  update(inst
  /*: Destination*/
  , updates
  /*: Destination | Object*/
  ) {
    const id = inst.id;
    const {
      propertyId,
      businessId
    } = this.context && this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/destinations/${id}` : `/businesses/${businessId}/destinations/${id}`;
    const updatedProps = diff(inst, updates);
    const req = new this.client.Request(path, updatedProps, fields);
    req.parse = Destination.fromJson;
    req.serialize = Destination.serialize;
    return this.client.patch(req);
  }

  delete()
  /*: (Promise<boolean>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context && this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/destinations/${this.id}` : `/businesses/${businessId}/destinations/${this.id}`;
    return this.client.delete(new this.client.Request(path));
  }

}

class DestinationsRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.context = context;
    this.client = client;

    this.for = (id
    /*: destinationId*/
    ) => new DestinationRepo(client, id, this.context);

    this.icanhas = this.for;
  }

  list()
  /*: (Promise<Array<Destination>>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context && this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/destinations` : `/businesses/${businessId}/destinations`;
    return this.client.get(new this.client.Request(path, {}, fields));
  }

  create(instance
  /*: Destination*/
  )
  /*: (Promise<Destination>)*/
  {
    if (instance.id != null) throw new Error('Object already has id');
    const {
      propertyId,
      businessId
    } = this.context && this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/destinations` : `/businesses/${businessId}/destinations`;
    const req = new this.client.Request(path, instance, fields);
    req.parse = Destination.fromJson;
    req.serialize = Destination.serialize;
    return this.client.post(req);
  }

}

module.exports = DestinationsRepo;